export const addresses = {
  "dsaResolver": "0x621AD080ad3B839e7b19e040C77F05213AB71524",
}